import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { Container } from './style';
import CheckboxCard from '../../CheckboxCard';
import { Creators as ChatbotCreators } from '../../../store/ducks/chatbot';

class AgreeUseTerm extends Component {

  state = {}

  submit = (value, name) => {
    this.setState({ [name]: value });
    this.props.setChatbotSaga(value, this.props);
  }

  render() {
    return (
      <Container>
        {
          <CheckboxCard
            style={{ root: { padding: '5px' } }}
            handleChange={this.submit}
            value={this.state[this.props.step.id]}
            name={this.props.step.id}
            title={<div>Concordo com os termos de uso e política de privacidade</div>}
          />
        }
      </Container>
    )
  }

}

export default compose(connect(null, { ...ChatbotCreators }))(AgreeUseTerm);